import { Button, Col, Form, Input, InputNumber, Row, message } from "antd";
import React, { useState } from "react";
import {
  useParams,
  useNavigate,
  useLocation,
  navigate,
} from "react-router-dom";
import Footer from "../../../components/common/Footer";
import PageHeading from "../../../components/common/PageHeading";
import { auth, db } from "../../../firebase";
import { useAuthState } from "react-firebase-hooks/auth";

import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { useEffect } from "react";
import { toast } from "react-hot-toast";

const NewKeys = () => {
  const location = useLocation();
  const { id } = useParams();
  const navigate = useNavigate();
  const [companyName, setcompanyName] = useState("");
  const [dt, setData] = useState([]);
  const [user, loading] = useAuthState(auth);
  const [datafetched, setDatafetched] = useState(false);
  const queryParams = new URLSearchParams(location.search);

  const { TextArea } = Input;

  const handleNewKeys = () => {
    // navigate(`/property-tabs/property/${id}`);
  };
  const editParam = queryParams.get("edit");
  // console.log("editParam:", editParam);
  const fetchPropertyById = async (companyName, propertyId) => {
    try {
      const companiesRef = collection(db, "companies");
      const companyDocRef = doc(companiesRef, companyName);
      const propertyDocRef = doc(companyDocRef, "properties", propertyId);
      const propertyDocSnapshot = await getDoc(propertyDocRef);

      if (propertyDocSnapshot.exists()) {
        const propertyData = propertyDocSnapshot.data();
        setData(propertyData);
        setDatafetched(true);
        // console.log("Property:", propertyData);
        // Process the property or update state as needed
      } else {
        console.log("Property does not exist");
      }
    } catch (error) {
      console.log("Error getting property:", error);
    }
  };

  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user.uid));

      getDocs(userData)
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const res = doc.data();
            setcompanyName(res.companyName);
          });
        })
        .catch((error) => {
          console.log("Error getting users: ", error);
        });
    } catch (err) {
      console.error(err);
    }
  };
  const updateKeys = async (data) => {
    try {
      const companiesRef = collection(db, "companies");
      const companyDocRef = doc(companiesRef, companyName);
      const propertyDocRef = doc(companyDocRef, "properties", id); // Adjusted document reference

      const updatedFee = {
        Description: data.Description || "",
        TotalKeys: data.TotalKeys || "",
        keyID: data.keyID || "",
      };

      const updatedManagementFees = dt?.keys ? [...dt?.keys] : [];
      updatedManagementFees.splice(editParam ? editParam : 0, 0, updatedFee);

      const managementFees = {
        keys: updatedManagementFees,
      };

      await updateDoc(propertyDocRef, managementFees);

      // Show success message if update is successful
      message.success("Keys Data Updated Successfully", 3);
    } catch (error) {
      console.log("Error updating keys data:", error);
      // Show error message if update fails
      message.error("Failed to update keys data", 3);
    }
  };

  const onFinish = (fieldsValue) => {
    console.log("Success:", fieldsValue);
    updateKeys(fieldsValue).then(() => {
      navigate(`/property-tabs/property/${id}`);
    });
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    // setIsWaiting(false);
  };
  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);

  useEffect(() => {
    if (companyName) {
      fetchPropertyById(companyName, id);
    }
  }, [companyName]);

  const defaultValues = {
    keyID: dt?.keys?.[editParam]?.keyID ?? "",
    Description: dt?.keys?.[editParam]?.Description ?? "",
    TotalKeys: dt?.keys?.[editParam]?.TotalKeys ?? "",
  };

  console.log("defaultValues", defaultValues);
  return (
    datafetched && (
      <>
        <div className="page-container">
          <div className="main-container">
            <PageHeading heading="New Key" />
            <Form
              name="basic"
              initialValues={editParam ? defaultValues : {}}
              autoComplete="off"
              layout="vertical"
              onFinish={onFinish}
            >
              <Form.Item label="Key ID" name="keyID" required>
                <Input />
              </Form.Item>
              <Form.Item label="Description" name="Description">
                <TextArea
                  style={{
                    height: 60,
                    resize: "none",
                  }}
                />
              </Form.Item>
              <Form.Item label="Total Keys" name="TotalKeys" required>
                <InputNumber type="number" style={{ width: "100%" }} />
              </Form.Item>

              <Row gutter={16}>
                <Col>
                  <Button
                    type="primary"
                    onClick={handleNewKeys}
                    htmlType="submit"
                  >
                    Save
                  </Button>
                </Col>
                <Col>
                  <Button onClick={handleNewKeys}>Cancel</Button>
                </Col>
              </Row>
            </Form>
            <Footer />
          </div>
        </div>

        <div className="RightSidebar"></div>
      </>
    )
  );
};

export default NewKeys;
